var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('h2',{staticClass:"cac-page__header",class:{ 'text-center': _vm.centered },attrs:{"id":_vm.pageHeaderId}},[_vm._v(_vm._s(_vm.title)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }